import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import './index.css';

// Version Identifier for Deployment Verification
console.log("%c KidCash v1.1.0 - Supabase Live Active ", "background: #4f46e5; color: #fff; font-weight: bold; padding: 4px; border-radius: 4px;");

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>
);